module.exports = __webpack_public_path__ + "img/HVBm4msmmok36SkqEOXZYzd00k6uwd1RhUAFLB08.733e07fd.png";